import Constants from 'src/core/utils/Constants';
import flagDe from 'assets/flags/de.png';
import flagEn from 'assets/flags/en.png';
import flagFr from 'assets/flags/fr.png';
import flagNl from 'assets/flags/nl.png';

export type AppLocale = (typeof appLocales)[number];
export type LocaleFlagSource = number | string | { uri: string };

export const locales = [Constants.localeNl, Constants.localeDe, Constants.localeEn, Constants.localeFr] as const;
export const appLocales = [Constants.localeNl, Constants.localeDe] as const;
export const isAppLocale = (value: string): value is AppLocale => (appLocales as readonly string[]).includes(value);

export type Locale = (typeof locales)[number];

export const localeFlags: Record<Locale, LocaleFlagSource> = {
	[Constants.localeNl]: flagNl,
	[Constants.localeDe]: flagDe,
	[Constants.localeEn]: flagEn,
	[Constants.localeFr]: flagFr,
};

export const isLocale = (value: string): value is Locale => (locales as readonly string[]).includes(value);

export const localeFlag = (value: string): LocaleFlagSource =>
	isLocale(value) ? localeFlags[value] : localeFlags[Constants.localeNl];
